import grassSrc from "../assets/textures/grass2.jpg";

export const PITCH_W   = 700;
export const PITCH_H   = 450;
export const FIELD_PAD = 20;

export const grassImage = new Image();
let grassPattern = null;
let pendingCallbacks = [];

grassImage.onload = () => {
  grassPattern = null;
  pendingCallbacks.forEach(cb => cb());
  pendingCallbacks = [];
};
grassImage.src = grassSrc;

export function onGrassReady(cb) {
  if (grassImage.complete) { cb(); return null; }
  pendingCallbacks.push(cb);
  return () => { pendingCallbacks = pendingCallbacks.filter(c => c !== cb); };
}

// vertical=true draws the pitch in portrait (goal-to-goal along the Y axis);
// the pitch is symmetric top/bottom so drawPitch doesn't care which goal is which.
export function drawPitch(ctx, w, h, vertical = false) {
  if (!grassPattern && grassImage.complete) grassPattern = ctx.createPattern(grassImage, "repeat");
  ctx.fillStyle = grassPattern ?? "#2d7a2d";
  ctx.fillRect(0, 0, w, h);

  ctx.strokeStyle = "rgba(255,255,255,0.8)";
  ctx.lineWidth = 2;

  const pad = FIELD_PAD;
  const fw = w - 2 * pad;
  const fh = h - 2 * pad;

  // Degenerate size (transient during content-fit resize) — skip field markings
  // to avoid negative radii/dimensions; a real resize redraws it.
  if (fw <= 0 || fh <= 0) return;

  ctx.strokeRect(pad, pad, fw, fh);

  if (!vertical) {
    // Centre line (vertical), circle, dot
    ctx.beginPath();
    ctx.moveTo(w / 2, pad);
    ctx.lineTo(w / 2, h - pad);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(w / 2, h / 2, fh * 0.15, 0, Math.PI * 2);
    ctx.stroke();

    ctx.fillStyle = "rgba(255,255,255,0.8)";
    ctx.beginPath();
    ctx.arc(w / 2, h / 2, 3, 0, Math.PI * 2);
    ctx.fill();

    // Penalty areas — depth = 16 % of the field LENGTH (fw), 58 % wide (fh)
    const penDepth = fw * 0.16, penHeight = fh * 0.58;
    const penY = pad + (fh - penHeight) / 2;
    ctx.strokeRect(pad, penY, penDepth, penHeight);
    ctx.strokeRect(w - pad - penDepth, penY, penDepth, penHeight);

    // Goals (left/right)
    const goalHeight = fh * 0.2, goalDepth = 14;
    const goalY = pad + (fh - goalHeight) / 2;
    ctx.strokeRect(pad - goalDepth, goalY, goalDepth, goalHeight);
    ctx.strokeRect(w - pad, goalY, goalDepth, goalHeight);
  } else {
    // Vertical: length runs along Y (fh), width along X (fw).
    // Centre line (horizontal), circle (radius from the WIDTH now), dot
    ctx.beginPath();
    ctx.moveTo(pad, h / 2);
    ctx.lineTo(w - pad, h / 2);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(w / 2, h / 2, fw * 0.15, 0, Math.PI * 2);
    ctx.stroke();

    ctx.fillStyle = "rgba(255,255,255,0.8)";
    ctx.beginPath();
    ctx.arc(w / 2, h / 2, 3, 0, Math.PI * 2);
    ctx.fill();

    // Penalty areas — depth = 16 % of the LENGTH (fh), 58 % wide (fw)
    const penDepth = fh * 0.16, penWidth = fw * 0.58;
    const penX = pad + (fw - penWidth) / 2;
    ctx.strokeRect(penX, pad, penWidth, penDepth);
    ctx.strokeRect(penX, h - pad - penDepth, penWidth, penDepth);

    // Goals (top/bottom)
    const goalWidth = fw * 0.2, goalDepth = 14;
    const goalX = pad + (fw - goalWidth) / 2;
    ctx.strokeRect(goalX, pad - goalDepth, goalWidth, goalDepth);
    ctx.strokeRect(goalX, h - pad, goalWidth, goalDepth);
  }
}
